<template>
  <page :title="i18n.title">
    <div class="confirm-warp">
      <div class="confirm-info">
        <div class="confirm-title">{{ i18n.pay_label }}</div>
        <div class="confirm-price">
          {{ currency }}{{ payMode === "creditcard" ? cabinet.yajin : price }}
        </div>
        <!-- 补差租借：余额已抵扣部分押金，此处仅收需补足的差额 -->
        <div class="confirm-balance-tips" v-if="Number(balance) > 0">
          {{ i18n.balance_deduction_tips.format(currency, balance, price) }}
        </div>
        <!-- <div class="confirm-icon">
            <img src="../../assets/imgs/icon_tips.png" />
            <span>{{ payType === 'YJ' ? i18n.price_tips : i18n.auth_tips.format(currency, price) }}</span>
          </div> -->
      </div>
      <div class="confirm-payment-label">
        <span>{{ i18n.pay_type }}</span>
      </div>
      <div class="confirm-payment">
        <!-- <div class="confirm-payment-item" @click="payMode='paypal'">
            <div class="confirm-payment-item-info">
              <img src="../../assets/imgs/icon_paypal.png" />
              <div class="content">
                <div class="title">Paypal</div>
              </div>
            </div>
            <div class="confirm-payment-item-checked">
              <img v-if="payMode==='paypal'" src="../../assets/imgs/checkbox_selected.png" />
            </div>
          </div> -->
        <template v-for="item in payModeList">
          <div
            :key="item.pId"
            v-if="
              item.phone === 'all' ||
              item.phone === system ||
              item.phone === browser ||
              (item.phone === 'phone' && system !== '')
            "
          >
            <div
              class="confirm-payment-item"
              :class="{
                bordermaincolor:
                  payMode === item.pPaymentType && item.pId === pId
              }"
              @click="onPayMode(item)"
            >
              <div class="confirm-payment-item-info">
                <img
                  v-if="
                    item.pPaymentType === 'GOOGLE_PAY' ||
                    item.pPaymentType === 'STRIPE_GOOGLE'
                  "
                  :src="require('../../assets/imgs/icon_googlepay.png')"
                />
                <img
                  v-else-if="
                    item.pPaymentType === 'APPLE_PAY' ||
                    item.pPaymentType === 'STRIPE_APPLE'
                  "
                  :src="require('../../assets/imgs/icon_applepay.png')"
                />
                <img
                  v-else-if="item.pPaymentType === 'PAYPAL'"
                  :src="require('../../assets/imgs/icon_paypal.png')"
                />
                <img
                  v-else
                  :src="require('../../assets/imgs/icon_creditcard.png')"
                />
                <div class="content">
                  <div class="title">{{ item.label }}</div>
                </div>
              </div>
              <div class="confirm-payment-item-checked">
                <img
                  v-if="payMode === item.pPaymentType && item.pId === pId"
                  src="../../assets/imgs/checkbox_selected.png"
                />
              </div>
            </div>
            <div v-if="item.paymentConfig" class="confirm-payment-item-operate">
              <span
                class="confirm-payment-item-operate-text"
                @click="deletePayCard(item)"
                >{{ i18n.deletecard }}</span
              >
            </div>
          </div>
        </template>
      </div>
      <div class="confirm-btns">
        <div class="btn" @click="onPay" :disabled="disabled">
          {{ i18n.submit }}
        </div>
      </div>
      <popup-warp v-model="isCreditcard">
        <div>
          <div class="creditcard-input">
            <div id="credit-card-element"></div>
          </div>
          <div class="btn creditcard-btn" @click="onStripeSetup">
            {{ i18n.paynow }}
          </div>
        </div>
      </popup-warp>
      <!-- PayStack 邮箱输入弹窗（短信注册用户无邮箱时弹出），点遮罩可取消 -->
      <popup-warp v-model="showEmailDialog">
        <div class="paystack-email-popup">
          <div class="paystack-email-title">Enter your email</div>
          <div class="paystack-email-bound" v-if="dvaBoundEmail">
            Currently bound: {{ dvaBoundEmail }}
          </div>
          <div class="paystack-email-desc">PayStack requires your email address for payment receipt.</div>
          <div class="paystack-email-input">
            <input
              type="email"
              v-model="paystackEmail"
              placeholder="your@email.com"
            />
          </div>
          <div class="paystack-email-btn" @click="onEmailDialogConfirm">
            Confirm
          </div>
        </div>
      </popup-warp>
      <!-- DVA 授权确认弹窗：说明授权费/签约，用户确认后才发起建号+授权 -->
      <popup-warp v-model="showDvaAuthDialog">
        <div class="paystack-email-popup">
          <div class="paystack-email-title">{{ i18n.dva_auth_title }}</div>
          <div class="paystack-email-desc">{{ dvaAuthDesc }}</div>
          <div class="paystack-email-btn" @click="onDvaAuthConfirm">
            {{ i18n.dva_continue }}
          </div>
        </div>
      </popup-warp>
      <!-- DVA 支付确认弹窗：已授权银行 + 租借金额二次确认 -->
      <popup-warp v-model="showDvaPayDialog">
        <div class="paystack-email-popup">
          <div class="paystack-email-title">{{ i18n.dva_pay_title }}</div>
          <div class="paystack-email-desc">{{ dvaPayDesc }}</div>
          <div class="paystack-email-btn" @click="onDvaPayConfirm">
            {{ i18n.dva_confirm_pay }}
          </div>
        </div>
      </popup-warp>
    </div>
  </page>
</template>

  <script>
import { mapState } from "vuex"
import { getToken } from "../../utils/stripe_pay.js"
import {
  PAYPAL_PREAUTH,
  PAYMODE,
  MIDTRANS_RECHARGE,
  MIDTRANS_PAYORDER,
  SAVED_CARD_TO_RENT,
  SAVED_CARD_RENT,
  MYFATOORAH_PAYORDER,
  MYFATOORAH_RECHARGE,
  PAYSTACK_DVA_ASSIGN,
  PAYSTACK_DVA_QUERY,
  PAYSTACK_DVA_MANDATE_INIT,
  PAYSTACK_DVA_MANDATE_QUERY,
  STRIPE_V2_RECHARGE,
  STRIPE_V2_SYNC,
  STRIPE_V2_SAVE_CARD,
  PAYSTACK_CARD_RENT,
  PAYSTACK_CARD_DELETE
} from "../../apis/payment"
import { USER_CARD, REMOVE_CARD } from "../../apis/user.js"

import stripeMixin from "../../mixins/stripe"
import { PopupWarp } from "../../components/popup"
export default {
  mixins: [stripeMixin],
  components: {
    PopupWarp
  },
  computed: {
    ...mapState([
      "system",
      "browser",
      "cabinet",
      "user",
      "qrcode",
      "wallet",
      "agentId"
    ]),
    i18n() {
      return this.$t("confirm")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    currency() {
      if (this.cabinet) {
        return this.cabinet.currencyName
      } else {
        return this.user.pcurrencyName
      }
    },
    // DVA 授权确认文案：authFee>0（测试模式）展示扣费金额；生产模式纯签约不出现金额
    dvaAuthDesc() {
      return this.dvaAuthFee > 0
        ? this.i18n.dva_auth_desc_fee.format(this.currency, this.dvaAuthFee)
        : this.i18n.dva_auth_desc_free
    },
    // DVA 支付确认文案：已授权银行 + 租借金额
    dvaPayDesc() {
      return this.i18n.dva_pay_desc.format(this.dvaBankName, this.currency, this.price)
    }
  },
  watch: {
    payMode(val, oldVal) {
      console.log("payMode", val)
      if (
        val === "APPLE_PAY" ||
        val === "STRIPE_APPLE" ||
        val === "STRIPE_GOOGLE" ||
        val === "GOOGLE_PAY"
      ) {
        if (!this.stripePayRequest) {
          this.disabled = true
          this.$loading(true)
          this.getStripeToken()
        } else {
          this.disabled = false
        }
      } else {
        this.disabled = false
      }
    },
    stripePayRequest(val, oldVal) {
      this.disabled = !val
    }
  },
  data() {
    return {
      price: 0,
      // 补差租借：balance 为当前钱包余额（仅用于展示），fullAmount 为预授权需冻结的全额
      balance: "",
      fullAmount: 0,
      payType: "YJ",
      formId: "",
      cabinetID: "",
      yaJinType: null,
      pdailiId: "",
      payMode: "STRIPE_CARD",
      pId: "", // 代理或平台支付配置id
      currencySymbol: "$",
      country: "US", // 国家
      currencyname: "usd", // 货币类型
      publicKey: "", // 支付通道的公钥
      paymentConfig: {},
      disabled: false,
      stripePayRequest: null,
      isCreditcard: false,
      cardStyle: {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      },
      creditcard: null,
      clientSecret: null,
      payModeList: [],
      orderId: "",
      phone: "",
      paystackEmail: "",
      dvaBoundEmail: "", // DVA 当前绑定邮箱（后端脱敏返回），录错/换绑可感知
      showEmailDialog: false,
      emailDialogCallback: "",
      showDvaAuthDialog: false, // DVA 授权确认弹窗（首次/重新授权，含授权费说明）
      showDvaPayDialog: false, // DVA 支付确认弹窗（已授权银行 + 租借金额二次确认）
      dvaAuthFee: 0, // 授权费（后端返回：测试模式 100 / 生产 0）
      dvaBankName: "" // 已授权银行（支付确认弹窗展示）
    }
  },
  methods: {
    // 支付方式选中
    onPayMode(v) {
      console.log("支付方式===", v)
      const configDetails = v.configDetails || {}
      this.pId = v.pId
      // PayStack 保存卡：pSecuritycode=PayStack 且有 paymentConfig → 走保存卡免密租借
      if (v.pSecuritycode === "PayStack") {
        this.payMode = "PAYSTACK_SAVED_CARD"
      } else {
        this.payMode = v.pPaymentType
      }
      this.currencySymbol = v.currencySymbol
      this.currencyname = configDetails.currency
      this.publicKey = v.publicKey
      this.country = configDetails.accountCountry
      this.paymentConfig = v.paymentConfig
    },
    // 删除支付卡
    deletePayCard(v) {
      // PayStack 保存卡走专用删除接口
      if (v.pSecuritycode === "PayStack") {
        this.$loading(true)
        this.$postV2(
          PAYSTACK_CARD_DELETE,
          { cardId: v.pId },
          (resp) => {
            this.$loading(false)
            this.$toast(this.i18nMsg.success)
            this.getPayMode()
          },
          (error) => {
            this.$loading(false)
            this.$confirm({
              title: this.i18nMsg.title,
              content: error,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            })
          }
        )
        return
      }
      this.$post(
        `${REMOVE_CARD + v.pId}`,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          this.$toast(this.i18nMsg.success)
          this.getPayMode()
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          })
        }
      )
    },
    onPay() {
      if (this.disabled) return // 防连点：主按钮为 div，原生 disabled 不拦截 click
      console.log(`payMode-${this.payMode}`)
      if (this.payMode === "PAYPAL") {
        this.onPaypal()
      } else if (
        this.payMode === "APPLE_PAY" ||
        this.payMode === "STRIPE_APPLE" ||
        this.payMode === "STRIPE_GOOGLE" ||
        this.payMode === "GOOGLE_PAY"
      ) {
        this.stripePayRequest.show()
      } else if (
        this.payMode === "STRIPE_CARD" ||
        this.payMode === "STRIPE_KLARNA"
      ) {
        this.onCreditcard(this.publicKey)
      } else if (
        this.payMode === "MIDTRANS_CARD" ||
        this.payMode === "MIDTRANS_GOPAY"
      ) {
        this.onMidtrans()
      } else if (this.payMode === "MyFatoorah") {
        this.onMyfatoorahCreditCard(this.publicKey)
      } else if (this.payMode === "PAYSTACK") {
        this.onPayStack()
      } else if (
        this.payMode === "PAYSTACK_DVA" ||
        this.payMode === "PayStack_DVA"
      ) {
        this.onPayStackDva()
      } else if (this.payMode === "PAYSTACK_SAVED_CARD") {
        this._doPayStackSavedCard()
      } else {
        this.$loading(true)
        setTimeout(() => {
          this.$loading(false)
          this.$router.replace("/result")
        }, 3000)
      }
    },
    checkOrder(tradeNo, payType, query) {
      if (payType === "CZ") {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.success_payment,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.replace("/mine")
        })
      } else {
        if (payType === "FK") {
          this.$router.replace(
            `/result?tradeNo=${tradeNo}&payMode=stripe&payType=FK`
          )
          return
        }
        this.$router.replace(`/result?tradeNo=${tradeNo}&payMode=stripe`)
      }
    },

    // 卡塔尔-创建预授权订单
    async onMyfatoorahCreditCard() {
      this.$loading(true)
      let cabinetID = this.cabinet && this.cabinet.cabinetID
      let payUrlBit = "PaymentURL"
      let url = MYFATOORAH_RECHARGE
      let query = {
        rentNow: true,
        rechargeType: "balance",
        qrcode: cabinetID,
        paymentId: this.pId
      }
      // 订单付款
      if (this.payType === "FK") {
        payUrlBit = "InvoiceURL"
        url = MYFATOORAH_PAYORDER
        // query = { paymentId: this.pId, outTradeNo: this.orderId, returnUri: '#/order' };
        query = { paymentId: this.pId, outTradeNo: this.orderId }
      }
      const headers = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
      this.$Request("post", url, query, headers)
        .then((resp) => {
          console.log("onMyfatoorahCreditCard~~ resp:", resp)
          this.$loading(false)
          if (resp.data) {
            const apiResult = resp.data.apiResult || {}
            if (apiResult[payUrlBit] && apiResult[payUrlBit].includes("http")) {
              window.location.href = apiResult[payUrlBit]
            } else if (resp.data.rentOrderId) {
              this.checkOrder(resp.data.rentOrderId, this.payType)
            }
          }
        })
        .catch((error) => {
          console.warn("onMyfatoorahCreditCard ~ error:", error)
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          })
            .then(() => {
              this.onMyfatoorahCreditCard(this.payMode.publicKey)
            })
            .catch(() => {})
        })
    },
    getStripeToken() {
      // 预授权冻结的是卡上额度、不经过钱包余额，按全额授权
      getToken(
        this.fullAmount || this.price,
        this.country,
        this.currencyname,
        this.onStripe
      )
        .then((data) => {
          console.log("stripe getToken", data)
          this.stripePayRequest = data
          this.$loading(false)
        })
        .catch((error) => {
          this.stripePayRequest = null
          console.log("stripe getTokenerr", error)
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_support,
            showCancel: false,
            confirmText: this.i18n.msg_fail_confirm
          })
        })
    },
    // apple和Google支付时调用
    onStripe(token, ev) {
      let datas = {}
      let valid = false
      if (this.cabinet && this.payType === "YJ") {
        valid = true
        datas = {
          bizScene: "PREAUTH",
          preAuthSubType: "OF_INTENT",
          qrcode: this.cabinet.qrcode,
          stripeToken: token,
          paymentId: String(this.pId)
        }
      } else if (this.price > 0 && this.payType === "FK") {
        valid = true
        datas = {
          bizScene: "ORDER_PAY",
          orderPaySubType: "STRIP_TOKEN",
          outTradeNo: this.orderId,
          couponNo: null,
          stripeToken: token,
          paymentId: String(this.pId)
        }
      }
      if (!valid) {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.error,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.push("/")
        })
        return
      }
      this.$postV2(
        STRIPE_V2_RECHARGE,
        datas,
        (resp) => {
          if (ev && ev.complete) {
            ev.complete("success")
          }
          this.$loading(false)
          console.log(resp)
          const v2Data = resp.data
          const tradeNo = v2Data.outTradeNo || ""
          if (this.payType === "CZ") {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.i18nMsg.success_payment,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            }).then(() => {
              this.$router.replace("/mine")
            })
          } else {
            this.$toast(this.i18nMsg.success_payment)
            if (this.payType === "FK") {
              this.$router.replace(
                `/result?tradeNo=${tradeNo}&payMode=stripe&payType=FK`
              )
              return
            }
            this.$router.replace(
              `/result?tradeNo=${tradeNo}&payMode=stripe`
            )
          }
        },
        (error) => {
          if (ev && ev.complete) {
            ev.complete("fail")
          }
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          })
        }
      )
    },
    onConfirmSaveCard(pid, id) {
      this.$loading(true)
      this.$postV2(
        STRIPE_V2_SAVE_CARD,
        {
          stage: "CONFIRM",
          paymentId: String(pid),
          setupIntentId: String(id)
        },
        (resp) => {
          this.$loading(false)
          console.log("saveCardConfirm====", resp)
          //   this.getCardList()
          this.saveToRent()
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nMsg.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onConfirmSaveCard(pid, id)
          })
          console.log(error)
        }
      )
    },
    saveToRent() {
      this.$loading(true)
      this.$get(
        `${SAVED_CARD_TO_RENT}`,
        {
          qrcode: this.cabinet.cabinetID || this.$route.query.qrcode
        },
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data && resp.data.out_trade_no) {
            this.checkOrder(resp.data.out_trade_no, this.payType)
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    },
    // 获取用户支付卡信息
    async getUserPayCard() {
      this.$loading(true)
      const qrcode = this.qrcode || this.$route.query.cabinetID
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode,
        orderId: "",
        agentld: this.agentId
      })
      let cardList = []
      if (data && data.length) {
        cardList = data.map((item) => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item
          }
        })
        this.cardList = cardList
      }
      this.$loading(false)
      return cardList
    },
    onPaypal() {
      this.$loading(true)
      let url =
        PAYPAL_PREAUTH + `/${this.qrcode || this.$route.query.cabinetID}`
      this.$post(
        url,
        {
          paymentId: this.pId
        },
        (resp) => {
          this.$loading(false)
          if (resp.data) {
            this.$loading(true)
            this.$store.commit("paypalTradeNo", resp.data.tradeNo)
            this.$store.commit("paymentId", this.pId)
            window.location.href = resp.data.approve
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onPaypal()
          })
          console.log(error)
        }
      )
    },
    onMidtrans() {
      this.$loading(true)
      let url = ""
      let datas = {}
      if (this.payType === "YJ") {
        url = `${MIDTRANS_RECHARGE}`
        datas = {
          paymentId: this.pId,
          rechargeType: "balance",
          amount: this.price,
          qrcode: this.qrcode || this.$route.query.cabinetID,
          rentNow: true
        }
      } else {
        url = MIDTRANS_PAYORDER
        datas = {
          outTradeNo: this.orderId,
          paymentId: this.pId
        }
      }
      this.$post(
        url,
        datas,
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data && resp.data.redirectUrl) {
            window.location.href = resp.data.redirectUrl
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    },
    async cardToRent() {
      let url = `${SAVED_CARD_RENT}/${this.cabinet.cabinetID}`
      this.$loading(true)
      const result = await this.$Request("post", url, {
        cardId: this.pId,
        paymentId: this.paymentConfig.pId,
        // 预授权冻结的是卡上额度、不经过钱包余额，按全额授权
        amount: this.fullAmount || this.price
      })
      this.$loading(false)
      if (result.data && result.data.outTradeNo) {
        this.checkOrder(result.data.outTradeNo, this.payType)
      } else {
        this.$confirm({
          title: this.i18n.msg_fail_title,
          content: this.i18n.msg_fail_order,
          confirmText: this.i18n.msg_fail_retry,
          cancelText: this.i18n.msg_fail_cancel
        }).then(() => {
          this.cardToRent()
        })
      }
    },
    onCreditcard(publicKey) {
      // console.log('publicKey', publicKey)
      const { paymentWay } = this.$route.query
      let paymentId = this.pId
      if (this.paymentConfig && this.paymentConfig.pId) {
        paymentId = this.paymentConfig.pId
      }

      if (paymentWay === "PAYMENT_CARD") {
        return this.saveCard()
      }
      let datas = {}
      if (this.cabinet && this.payType === "YJ") {
        datas = {
          bizScene: "PREAUTH",
          preAuthSubType: "OF_INTENT",
          qrcode: this.cabinet.cabinetID,
          paymentId: String(paymentId),
          // 预授权冻结的是卡上额度、不经过钱包余额，按全额授权
          amount: String(this.fullAmount || this.price)
        }
        if (this.paymentConfig) {
          return this.cardToRent(this.paymentConfig)
        }
      } else if (this.price > 0 && this.payType === "FK") {
        datas = {
          bizScene: "ORDER_PAY",
          orderPaySubType: "PAY_ORDER",
          outTradeNo: this.orderId,
          couponNo: null,
          paymentId: String(paymentId)
        }
        if (this.paymentConfig) {
          datas.cardId = String(this.pId)
        }
      } else {
        datas = {
          bizScene: "RECHARGE",
          rechargeSubType: "WALLET",
          amount: String(this.price),
          paymentId: String(paymentId)
        }
      }
      this.$loading(true)
      this.$postV2(
        STRIPE_V2_RECHARGE,
        datas,
        (resp) => {
          this.$loading(false)
          console.log(STRIPE_V2_RECHARGE, resp)
          const v2Data = resp.data
          if (v2Data) {
            if (datas.cardId && this.payType === "FK") {
              this.checkOrder(v2Data.outTradeNo, this.payType)
              return
            }
            if (window.stripe && v2Data.action && v2Data.action.payload) {
              this.clientSecret = v2Data
              const layout = {
                layout: "tabs"
              }
              const options = {
                clientSecret: v2Data.action.payload.clientSecret,
                appearance: {
                  theme: "stripe"
                }
              }
              this.creditcard = window.stripe.elements(options)
              const paymentElement = this.creditcard.create("payment", layout)
              this.isCreditcard = true
              paymentElement.mount("#credit-card-element")
            } else {
              this.$toast("loading...")
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onCreditcard(publicKey)
          })
          console.log(error)
        }
      )
    },

    saveCard() {
      const { paymentWay, paymentId } = this.$route.query
      console.log("this.payMode", this.payMode)
      if (!this.user) {
        this.$toast(this.i18nMsg.unlogin)
        return
      }
      if (!this.payMode || !this.pId) {
        this.$toast(this.i18nMsg.nopaymode)
        return
      }
      this.$loading(true)
      this.$postV2(
        STRIPE_V2_SAVE_CARD,
        { stage: "INTENT", paymentId: String(paymentId || this.pId) },
        (resp) => {
          this.$loading(false)
          this.creditOrder = resp.data
          if (paymentWay === "PAYMENT_CARD") {
            this.onLoadElement()
          }
          // this.onCreditcard(this.publicKey)

          console.log("saveCard====", resp)
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nMsg.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.saveCard()
          })
          console.warn(error)
        }
      )
    },
    onLoadElement() {
      const options = {
        clientSecret: this.creditOrder.action && this.creditOrder.action.payload
          ? this.creditOrder.action.payload.clientSecret
          : this.creditOrder.clientSecret,
        appearance: {
          theme: "stripe"
        }
      }
      if (window.stripe) {
        // this.loadStripeScript(this.payMode.publicKey)
        this.creditcard = window.stripe.elements(options)
        const paymentElement = this.creditcard.create("payment")
        this.isCreditcard = true
        // this.payListShow = false
        paymentElement.mount("#credit-card-element")
      } else {
        this.$toast("loading...")
        this.loadStripeScript()
        setTimeout(() => {
          this.onLoadElement()
        }, 500)
      }
    },
    onStripeSetup() {
      const vm = this
      vm.$loading(true)
      const { paymentWay } = this.$route.query
      // 失败事件回调
      const failCall = (result) => {
        console.log(result)
        vm.$loading(false)
        if (result.error) {
          vm.$toast(result.error.message)
        }
      }
      if (paymentWay === "PAYMENT_CARD") {
        const _pmid = (this.creditOrder.action && this.creditOrder.action.payload)
          ? this.creditOrder.action.payload.paymentId
          : this.creditOrder.paymentId
        let url = `${window.location.origin}#/confirm?qrcode=${this.cabinet.qrcode}&paymentId=${this.pId}&pmid=${_pmid}`
        window.stripe
          .confirmSetup({
            elements: vm.creditcard,
            confirmParams: {
              // Make sure to change this to your payment completion page
              return_url: url
            }
          })
          .then((result) => failCall(result))
      } else {
        window.stripe
          .confirmPayment({
            elements: vm.creditcard,
            confirmParams: {
              // Make sure to change this to your payment completion page
              return_url: `${window.location.href}&paymentId=${this.pId}`
            }
          })
          .then((result) => failCall(result))
      }
    },
    confirmSetup(id) {
      const { paymentWay } = this.$route.query
      this.$loading(true)
      this.$getV2(
        `${STRIPE_V2_SYNC}?tradeNo=${id}`,
        {},
        (resp) => {
          this.$loading(false)
          this.isCreditcard = false
          if (paymentWay === "PAYMENT_SAVED_PROPAY") {
            this.saveCard()
          }
          const tradeNo = resp.data.outTradeNo || ""
          let jumpUrl = `/result?tradeNo=${tradeNo}&payMode=stripe`
          if (this.payType !== "YJ") {
            jumpUrl = `/result?tradeNo=${tradeNo}&payMode=stripe&payType=${this.payType}`
          }
          this.$router.replace(jumpUrl)
          console.log(resp)
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    // PayStack 下单入口：先校验邮箱（PayStack 必填），无有效邮箱则弹窗让用户输入
    onPayStack() {
      this.emailDialogCallback = "paystack"
      let email = this.user && this.user.pUnionid
      if (!email || email.indexOf("@") === -1) {
        // 无有效邮箱，弹出输入框；邮箱登录用户默认填充 user.email
        this.paystackEmail = (this.user && this.user.email) || ""
        this.showEmailDialog = true
        return
      }
      this._doPayStack(email)
    },
    // 邮箱弹窗确认：根据触发来源分发到对应支付流程
    onEmailDialogConfirm() {
      let email = (this.paystackEmail || "").trim()
      if (!email || email.indexOf("@") === -1) {
        this.$toast("Please enter a valid email")
        return
      }
      this.showEmailDialog = false
      if (this.emailDialogCallback === "dva") {
        this._preflightDva(email)
      } else {
        this._doPayStack(email)
      }
    },
    // PayStack 实际下单逻辑（v2 统一入口）
    _doPayStack(email) {
      this.$loading(true)
      let _paymentId = this.paymentConfig && this.paymentConfig.pId ? this.paymentConfig.pId : this.pId;
      let _cardId = this.paymentConfig && this.paymentConfig.pId ? this.pId : "";
      let datas = {}
      if (this.payType === "YJ" || this.payType === "CZ") {
        // 补差租借（payType=YJ）需携带 qrcode，后端充值成功后自动弹宝建租借订单
        let _qrcode = this.qrcode || this.$route.query.qrcode || (this.cabinet && this.cabinet.qrcode)
        datas = {
          bizScene: "RECHARGE",
          rechargeSubType: "WALLET",
          amount: String(this.price),
          paymentId: String(_paymentId),
          userCardId: _cardId || undefined,
          email: email,
          qrcode: this.payType === "YJ" ? _qrcode : undefined
        }
      } else {
        datas = {
          bizScene: "ORDER_PAY",
          orderPaySubType: "PAY_ORDER",
          outTradeNo: this.orderId,
          paymentId: String(_paymentId),
          userCardId: _cardId || undefined,
          email: email
        }
      }
      this.$postV2(
        STRIPE_V2_RECHARGE,
        datas,
        (resp) => {
          this.$loading(false)
          this.$store.commit('payType', this.payType)
          const v2Data = resp.data || {}
          // 内/外跳 result 页时携带 cabinetID，避免 store 被 destroyed 清空后取不到
          const cabinetId =
            (this.cabinet && this.cabinet.cabinetID) ||
            this.qrcode ||
            this.$route.query.cabinetID ||
            ""
          if (
            v2Data.action &&
            v2Data.action.type === "REDIRECT_URL" &&
            v2Data.action.payload &&
            v2Data.action.payload.authorizationUrl
          ) {
            // 跳 PayStack 托管页；支付完成后由后端 /app/payment/v2/redirect 回 result 页
            // 外跳前将 cabinetID 存到独立 key，后端回调 URL 不会带这个参数，
            // 而 cdb_cabinet 可能被 result 页 destroyed 钩子清空，所以用独立 key 保底
            if (cabinetId) {
              localStorage.setItem("cdb_borrow_cabinet_id", cabinetId)
            }
            window.location.href = v2Data.action.payload.authorizationUrl
          } else if (v2Data.outTradeNo) {
            // 有存卡免密已扣款 / 其他状态 → result 页轮询确认
            this.$router.replace(
              `/result?outTradeNo=${v2Data.outTradeNo}&payType=PayStack&cabinetID=${cabinetId}`
            )
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: error,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this._doPayStack(email)
          }).catch(() => {})
        }
      )
    },
    // PayStack DVA 虚拟账户支付入口：先校验邮箱，再预检 mandate 状态分流弹窗
    onPayStackDva() {
      console.log("[DVA] 入口 onPayStackDva:", {
        payType: this.payType,
        price: this.price,
        orderId: this.orderId || "",
        qrcode: this.qrcode || this.$route.query.qrcode || "",
        cabinet: this.cabinet && (this.cabinet.qrcode || this.cabinet.cabinetID)
      })
      this.emailDialogCallback = "dva"
      let email = this.user && this.user.pUnionid
      if (!email || email.indexOf("@") === -1) {
        // 邮箱登录用户默认填充 user.email
        this.paystackEmail = (this.user && this.user.email) || ""
        this.showEmailDialog = true
        return
      }
      this._preflightDva(email)
    },
    // DVA 预检：查 mandate 状态分流——已授权弹支付二次确认；否则弹授权确认（含授权费说明）。
    // 用户点确认前不发起任何建号/授权/扣款请求；预检失败兜底走授权弹窗（assign/mandate 幂等，不会误扣）。
    _preflightDva(email) {
      this.dvaEmail = email
      this.$loading(true)
      this.$getV2(
        PAYSTACK_DVA_MANDATE_QUERY,
        {},
        (resp) => {
          this.$loading(false)
          const mandateData = resp.data || {}
          console.log("[DVA] preflight mandate:", mandateData)
          this.dvaAuthFee = Number(mandateData.authFee || 0)
          if (mandateData.status === "ACTIVE") {
            this.dvaBankName = mandateData.bankName || ""
            this.showDvaPayDialog = true
          } else {
            this.showDvaAuthDialog = true
          }
        },
        () => {
          this.$loading(false)
          this.dvaAuthFee = 0
          this.showDvaAuthDialog = true
        }
      )
    },
    // 授权确认 → 关弹窗，发起建号 + mandate 授权链路（外跳银行授权页）
    onDvaAuthConfirm() {
      console.log("[DVA] 用户确认授权弹窗，email=", this.dvaEmail)
      this.showDvaAuthDialog = false
      this._doPayStackDva(this.dvaEmail)
    },
    // 支付二次确认 → 关弹窗，免密扣款租借金额（复用 mandate ACTIVE 链路）
    onDvaPayConfirm() {
      console.log("[DVA] 用户确认支付弹窗，bank=", this.dvaBankName, "amount=", this.price)
      this.showDvaPayDialog = false
      this._onMandateActive()
    },
    // PayStack DVA 虚拟账户实际支付逻辑
    _doPayStackDva(email) {
      this.dvaEmail = email // 保存 email 供后续 mandate 等步骤使用
      this.disabled = true // 防连点：分配/授权流程进行中禁用主按钮
      this.$loading(true)

      // 外跳前尽早持久化金额/类型，避免 async 流程中组件销毁或 price 变化导致回跳后丢失
      // （URL 回传为主、此处为兜底： mandate init 会把 amount/payType/qrcode 写入回调 URL）
      if (this.price > 0) {
        localStorage.setItem("cdb_dva_pay_amount", String(this.price))
      }
      localStorage.setItem("cdb_dva_pay_type", this.payType || "")
      localStorage.setItem("cdb_dva_session", "1")

      // Step 1: 确保 DVA 虚拟账户已分配（幂等）
      // 后端 @RequestParam 接收 email，需拼接到 URL query
      this.$postV2(
        `${PAYSTACK_DVA_ASSIGN}?email=${encodeURIComponent(email)}`,
        {},
        (resp) => {
          const dvaData = resp.data
          console.log("[DVA] assign 响应:", dvaData)
          if (dvaData.email) {
            this.dvaBoundEmail = dvaData.email // 展示当前绑定身份（脱敏）
          }

          if (dvaData.status === "ACTIVE") {
            this._onDvaReady()
          } else if (dvaData.status === "ASSIGNING") {
            // 异步分配中，轮询等待
            this._pollDvaStatus()
          } else {
            // FAILED / NONE → 重试
            this.$loading(false)
            this.$toast(dvaData.status === "FAILED" ? "Virtual account assignment failed" : "Unknown status")
          }
        },
        (error) => {
          this.$loading(false)
          this.disabled = false
          console.error("DVA assign error:", error)
          this.$toast(error)
        }
      )
    },
    // 轮询 DVA 分配状态
    _pollDvaStatus(retryCount = 0) {
      if (retryCount >= 20) {
        this.$loading(false)
        this.disabled = false
        this.$toast("Virtual account assignment timeout, please retry")
        return
      }
      setTimeout(() => {
        this.$getV2(
          PAYSTACK_DVA_QUERY,
          {},
          (resp) => {
            const dvaData = resp.data
            if (dvaData.email) {
              this.dvaBoundEmail = dvaData.email
            }
            if (dvaData.status === "ACTIVE") {
              this._onDvaReady()
            } else if (dvaData.status === "ASSIGNING") {
              this._pollDvaStatus(retryCount + 1)
            } else {
              this.$loading(false)
              this.disabled = false
              this.$toast("Virtual account assignment failed")
            }
          },
          (error) => {
            this.$loading(false)
            this.disabled = false
            this.$toast(error)
          }
        )
      }, 2000)
    },
    // DVA 已就绪 → 检查 / 发起 Mandate 授权
    _onDvaReady() {
      // 查询 mandate 状态
      this.$getV2(
        PAYSTACK_DVA_MANDATE_QUERY,
        {},
        (resp) => {
          const mandateData = resp.data
          console.log("[DVA] _onDvaReady mandate 查询:", mandateData)

          if (mandateData.status === "ACTIVE") {
            this._onMandateActive()
          } else {
            // 未激活 → 发起授权
            this._initMandate()
          }
        },
        () => {
          // 查询失败，尝试发起授权
          this._initMandate()
        }
      )
    },
    // 发起 Mandate 授权 → 跳转银行授权页
    _initMandate() {
      // outTradeNo/amount/payType/qrcode 随初始化写入回调 URL，后端在回跳时原样透传
      // （dvaAmount/dvaType/dvaQrcode），result 页回跳后直接据 URL 参数发起扣款；
      // localStorage 仅作兜底（移动端跨站跳转后浏览器可能清理，不能作为唯一载体）
      let _mandateQrcode = this.qrcode || this.$route.query.qrcode || (this.cabinet && this.cabinet.qrcode) || ""
      const mandateQuery = `?outTradeNo=${encodeURIComponent(this.orderId || "")}`
        + (this.dvaEmail ? `&email=${encodeURIComponent(this.dvaEmail)}` : "")
        + (!this.orderId && this.price ? `&amount=${encodeURIComponent(this.price)}` : "")
        + (!this.orderId && this.payType ? `&payType=${encodeURIComponent(this.payType)}` : "")
        + (!this.orderId && _mandateQrcode ? `&qrcode=${encodeURIComponent(_mandateQrcode)}` : "")
      console.log("[DVA] mandate init 请求:", mandateQuery)
      this.$postV2(
        `${PAYSTACK_DVA_MANDATE_INIT}${mandateQuery}`,
        {},
        (resp) => {
          const mandateData = resp.data
          console.log("[DVA] mandate init 响应:", mandateData)

          if (mandateData.action && mandateData.action.type === "AUTHORIZE_URL") {
            const authorizeUrl = mandateData.action.payload.authorizeUrl
            if (authorizeUrl) {
              // DVA 外跳前保存 cabinetID，回跳后 result 页 onBorrow 用
              const cabinetId =
                (this.cabinet && this.cabinet.cabinetID) ||
                this.qrcode ||
                this.$route.query.cabinetID ||
                ""
              if (cabinetId) {
                localStorage.setItem("cdb_borrow_cabinet_id", cabinetId)
              }
              // 会话标记（非 amount）：result 页 created 不会据此重新下单，仅供失败后 onReload
              // 识别 DVA 会话走重新下单；金额/类型仍存 cdb_dva_pay_amount/type（_doPayStackDva 入口已写）
              localStorage.setItem("cdb_dva_session", "1")
              // cdb_dva_pay_amount / cdb_dva_pay_type 已在 _doPayStackDva 入口持久化，此处无需重复写入
              // 回跳 URL 带 payType=PayStack（非 PayStack_DVA），result 页按 store 分派；
              // 与 _doPayStack 外跳路径对齐，外跳前同步持久化到 cdb_payType
              this.$store.commit("payType", this.payType)
              console.log("[DVA] 外跳授权页:", authorizeUrl, "| localStorage 快照:", {
                amount: localStorage.getItem("cdb_dva_pay_amount"),
                type: localStorage.getItem("cdb_dva_pay_type"),
                cabinetId: localStorage.getItem("cdb_borrow_cabinet_id")
              })
              window.location.href = authorizeUrl
            } else {
              this.$loading(false)
              this.disabled = false
              this.$toast("Authorization URL not available")
            }
          } else {
            this.$loading(false)
            this.disabled = false
            this.$toast("Failed to initialize authorization")
          }
        },
        (error) => {
          this.$loading(false)
          this.disabled = false
          console.error("Mandate init error:", error)
          this.$toast(error)
        }
      )
    },
    // Mandate 已激活 → v2 统一下单（DVA 免密扣款），复用 result 页 PayStack sync 轮询
    _onMandateActive() {
      let datas
      // 方法级作用域声明：受理成功回调中需读取（存重试 cabinetID），不得限在 else 块内
      let _dvaQrcode = this.qrcode || this.$route.query.qrcode || (this.cabinet && this.cabinet.qrcode) || ""
      if (this.orderId) {
        // 订单模式（FK 房费/欠费）：outTradeNo 驱动
        datas = {
          bizScene: "ORDER_PAY",
          orderPaySubType: "PAY_ORDER",
          outTradeNo: this.orderId,
          dva: true
        }
      } else {
        // 充值模式（YJ 补差 / CZ 余额）：amount 驱动
        // 补差租借（payType=YJ）携带 qrcode，弹宝由前端 result 页主动调 useBalanceToRent 完成
        datas = {
          bizScene: "RECHARGE",
          rechargeSubType: "WALLET",
          amount: String(this.price || ""),
          dva: true,
          // 与 result.vue _dvaStartPay 严格对齐（两处二次扣款入口参数必须一致）。
          // rechargeType 取 "balance" 而非 "deposit"，对齐 Midtrans(L698)/MyFatoorah(L428) 既有 YJ 补差契约：
          //   balance → payOrderByDva paytype=1 → addBalance() 写 wallet.P_BALANCE；
          //   deposit → paytype=0 → addDepositAmount() 写 wallet.P_DEPOSIT_AMOUNT，
          // 而 useBalanceToRent(CdbCabinetController L612) 只读 P_BALANCE，传 deposit 会让租借接口
          // 永远看不见这笔钱：返回 needRechargeAmount 差额、无 outTradNo，前端 onBorrow 弹 "Request failed"
          rechargeType: this.payType === "YJ" ? "balance" : undefined,
          qrcode: this.payType === "YJ" ? _dvaQrcode : undefined
        }
      }
      console.log("[DVA] 已授权直接扣款 v2 下单:", JSON.stringify(datas))
      this.$postV2(
        STRIPE_V2_RECHARGE,
        datas,
        (resp) => {
          this.$loading(false)
          const v2Data = resp.data || {}
          console.log("[DVA] v2 下单响应:", v2Data)
          if (v2Data.outTradeNo && v2Data.status !== "FAILED") {
            this.$store.commit('payType', this.payType)
            // 本路径不经过 _doPayStackDva，localStorage 无 DVA 痕迹：补存重试快照，供 result 页
            // 失败后 onReload 识别 DVA 会话、重新下单（而非重轮询已失败单）
            if (this.price > 0) {
              localStorage.setItem("cdb_dva_retry_amount", String(this.price))
            }
            // 订单会话（FK）标记：result 页重试时以业务订单号重走 ORDER_PAY
            localStorage.setItem("cdb_dva_retry_type", this.orderId ? "ORDER" : (this.payType || ""))
            if (this.orderId) {
              // 下单成功后 URL 会被规范化为充值单号，故业务订单号需独立留存供重试
              localStorage.setItem("cdb_dva_retry_order", this.orderId)
            }
            // YJ 补差会话：补存 cabinetID 作重试 qrcode 来源（result 页重下单与 onBorrow 均需要）
            if (this.payType === "YJ" && _dvaQrcode) {
              localStorage.setItem("cdb_borrow_cabinet_id", _dvaQrcode)
            }
            localStorage.setItem("cdb_dva_session", "1")
            // 复用普通 PayStack 回跳分支：v2 sync 轮询 → SUCCESS → 按 payType 分派
            // dvaPaid=1 显式声明「本笔 DVA 已受理」：created 据此只轮询、绝不再下单；
            // 旧实现以「localStorage 有 cdb_dva_pay_amount」当作待下单信号，历史残留会把
            // 已受理单再下一笔（PayStack 侧重复扣款，且首笔永不 sync 落账）
            this.$router.replace(`/result?outTradeNo=${v2Data.outTradeNo}&payType=PayStack&dvaPaid=1`)
          } else {
            this.$toast((v2Data && v2Data.errorMsg) || "Payment failed")
          }
        },
        (error) => {
          this.$loading(false)
          this.disabled = false
          console.error("DVA pay order error:", error)
          this.$toast(error)
        }
      )
    },
    // PayStack 保存卡免密租借
    _doPayStackSavedCard() {
      if (!this.user) {
        this.$toast(this.i18nMsg.unlogin)
        return
      }
      this.$loading(true)
      let _qrcode = this.qrcode || this.$route.query.qrcode || (this.cabinet && this.cabinet.qrcode)
      this.$postV2(
        PAYSTACK_CARD_RENT,
        {
          cardId: this.pId,
          qrcode: _qrcode
        },
        (resp) => {
          this.$loading(false)
          this.$store.commit('payType', this.payType)
          const v2Data = resp.data || {}
          const cabinetId =
            (this.cabinet && this.cabinet.cabinetID) ||
            this.qrcode ||
            this.$route.query.cabinetID ||
            ""
          if (v2Data.outTradeNo) {
            this.$router.replace(
              `/result?outTradeNo=${v2Data.outTradeNo}&payType=PayStack&cabinetID=${cabinetId}`
            )
          } else {
            this.$toast(this.i18nMsg.error)
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    getPayMode() {
      console.log("hahah", this.cabinet, this.wallet)
      this.$loading(true)
      let agentId = ""
      // if (this.payType === "CZ") {
      //   agentId = this.wallet
      //     ? this.wallet.pDailiId
      //     : this.cabinet.userWallet.pDailiId
      // }
      this.$get(
        this.payType !== "CZ"
          ? `${PAYMODE}${`?id=${this.qrcode || this.$route.query.cabinetID}`}`
          : `${PAYMODE}?agentId=${agentId}`,
        {},
        async (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            let list = resp.data
            list.map((v, i, arr) => {
              if (v.pPaymentType === "STRIPE_CARD") {
                v.label = "Credit Card"
                v.phone = "all"
              } else if (
                v.pPaymentType === "APPLE_PAY" ||
                v.pPaymentType === "STRIPE_APPLE"
              ) {
                v.label = "Apple Pay"
                v.phone = "ios"
              } else if (
                v.pPaymentType === "GOOGLE_PAY" ||
                v.pPaymentType === "STRIPE_GOOGLE"
              ) {
                v.label = "Google Pay"
                v.phone = "android"
              } else if (v.pPaymentType === "PAYPAL") {
                v.label = "Paypal"
                v.phone = "all"
              } else if (v.pPaymentType === "STRIPE_KLARNA") {
                v.label = "Klarna"
                v.phone = "all"
              } else if (v.pPaymentType === "MIDTRANS_CARD") {
                v.label = "Credit Card"
                v.phone = "all"
              } else if (v.pPaymentType === "MIDTRANS_GOPAY") {
                v.label = "GOPAY"
              } else if (v.pPaymentType === "MyFatoorah") {
                v.label = "Credit Card"
                v.phone = "all"
              } else if (v.pPaymentType === "PAYSTACK") {
                v.label = "PayStack"
                v.phone = "all"
              } else if (
                v.pPaymentType === "PAYSTACK_DVA" ||
                v.pPaymentType === "PayStack_DVA"
              ) {
                v.label = "Virtual Account"
                v.phone = "all"
              }
              // list.push(v)
            })
            list = list.filter((v) => !!v.label)
            const plist = await this.getUserPayCard()
            list = [...plist, ...list]

            this.payModeList = list

            if (list.length > 0) {
              // let item = list.filter(v => {
              //   return v.pPaymentType === 'STRIPE_CARD'
              // })
              const configDetails = list[0].configDetails || {}
              this.payMode = list[0].pPaymentType
              this.currencySymbol = list[0].currencySymbol // 货币符号
              this.currencyname = configDetails.currency // 货币类型
              this.publicKey = list[0].publicKey || ""
              this.paymentConfig = list[0].paymentConfig
              this.pId = list[0].pId
              this.country = configDetails.accountCountry
              console.log(this.publicKey, this.payMode)
              const pPaymentType = list[0].pPaymentType
              if (
                list[0].publicKey &&
                pPaymentType !== "M-PESA" &&
                pPaymentType !== "MIDTRANS_CARD" &&
                pPaymentType !== "MIDTRANS_GOPAY"
              ) {
                this.loadStripeScript(list[0].publicKey)
              }
            }
            console.log("list======", list)
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode()
          })
          console.log(error)
        }
      )
    }
  },
  created() {
    this.Query = this.$route.query
    let { paymentId, pmid } = this.$route.query
    let price = this.$route.query.price
    let formId = this.$route.query.formId
    this.price = price ? Number(price) : 0
    this.balance = this.$route.query.balance || ""
    this.fullAmount = this.$route.query.fullAmount
      ? Number(this.$route.query.fullAmount)
      : 0
    this.orderId = this.$route.query.outTradeNo
    this.formId = formId
    this.payType = this.$route.query.payType
    this.cabinetID = this.$route.query.cabinetID
    this.yaJinType = this.$route.query.yaJinType
    const payId = new URLSearchParams(window.location.search).get(
      "payment_intent"
    )
    console.log(`query-payId:${payId}-paymentId:${paymentId}-pmid:${pmid}`)
    if (paymentId && pmid) {
      this.onConfirmSaveCard(paymentId, pmid)
    } else if (payId) {
      this.confirmSetup(payId)
    }
    this.getPayMode()
    console.log(this)
  }
}
</script>

  <style lang="less">
.noClick {
  opacity: 0.5;
  pointer-events: none;
  /* 禁止鼠标点击 */
}

.confirm-warp {
  height: calc(100vh - 120px);
  overflow-y: scroll;
  // background: #ffffff;
}

.confirm-info {
  text-align: center;
  padding: 40px;
}

.confirm-title {
  font-size: 36px;
}

.confirm-price {
  font-size: 80px;
  // 对齐 App 主题色
  color: var(--theme-color);
}

.confirm-balance-tips {
  margin-top: 10px;
  font-size: 28px;
  color: var(--text-sub);
}

.confirm-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }

  & span {
    text-align: left;
    font-size: 28px;
    color: var(--text-sub);
  }
}

.confirm-payment {
  margin: 30px;

  &-label {
    padding: 10px 30px;
    font-size: 36px;
    // 对齐 App：白底黑字
    color: var(--text-main);
    font-weight: bold;
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 30px 20px;
    border: solid 6px #ddd;
    border-radius: 20px;
    // 对齐 App 支付方式选项：itemColor 背景
    background: var(--item-bg);
    margin-top: 20px;

    & img {
      width: 40px;
      height: 40px;
    }

    &-info {
      display: flex;
      align-items: center;
      flex: 1;

      & .content {
        padding-left: 10px;
      }

      & .sub_title {
        font-size: 28px;
        color: var(--text-sub);
      }
    }
    &-operate {
      display: flex;
      justify-content: flex-end;
      &-text {
        padding: 4px 12px;
        font-size: 28px;
        color: var(--theme-color);
      }
    }
  }
}

.bordermaincolor {
  border-color: var(--theme-color);
}

.confirm-remark {
  padding: 0 32px;
}

.confirm-remark .title {
  margin-top: 40px;
  font-size: 32px;
}

.confirm-remark .desc {
  font-size: 28px;
  color: var(--text-sub);
  font-weight: 400;
  word-break: normal !important;
  white-space: normal !important;
}

.confirm-btns {
  padding: 60px 56px 20px;
}

.confirm-btns .btn {
  margin-top: 20px;
}

/* #ifdef MP-WEIXIN */
.confirm-btns button.btn {
  background-color: var(--theme-color);
}

/* #endif */
.confirm-checkbox {
  padding: 30px;

  & label {
    display: flex;
    align-items: center;
  }

  & span {
    // 对齐 App：协议文字黑色
    color: var(--text-main);
  }
}

.btn-paypal {
  background: #fec348 !important;
}

.btn-paypal img {
  width: 277px;
  height: 60px;
  margin: 18px 0;
}

.btn-applepay {
  background: #ffffff !important;
  color: #050608;
}

.btn-applepay img {
  width: 143px;
  height: 60px;
  margin: 18px 0;
}

.btn-googlepay {
  color: #5f6368;
  background: #ffffff !important;
}

.btn-googlepay img {
  width: 145px;
  height: 60px;
  margin: 18px 0;
}

.creditcard-input {
  margin: 48px 48px 80px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #e4e7ed;
}

.creditcard-btn {
  margin: 48px;
}

.confirm-row {
  margin: 36px 45px 140px;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 4px solid rgb(211, 211, 211);
  border-radius: 20px;

  .area {
    width: 100px;
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  input {
    font-size: 32px;
    width: 300px;
    flex: 1;
    height: 80px;
    padding: 0 20px;
    margin: 0;
    border: none;
    outline: none;
    background-color: rgba(0, 0, 0, 0);
  }

  .area-down {
    // margin-left: 10px;
    width: 0;
    height: 0;
    border-width: 10px 10px 0;
    border-style: solid;
    border-color: black transparent transparent;
  }

  .login-code {
    width: 180px;
    height: 60px;
    background-image: linear-gradient(
      to right,
      rgba(194, 194, 194, 1),
      rgba(252, 252, 252, 1)
    );

    img {
      width: 180px;
      height: 60px;
    }
  }
}

// PayStack 邮箱输入弹窗
.paystack-email-popup {
  padding: 60px 40px;
  text-align: center;
}
.paystack-email-title {
  font-size: 36px;
  font-weight: 600;
  color: var(--text-main);
  margin-bottom: 20px;
}
.paystack-email-bound {
  font-size: 24px;
  color: #e6a23c;
  margin-bottom: 12px;
}
.paystack-email-desc {
  font-size: 26px;
  color: var(--text-sub);
  margin-bottom: 40px;
}
.paystack-email-input {
  margin-bottom: 40px;
  input {
    width: 100%;
    height: 80px;
    line-height: 80px;
    padding: 0 20px;
    font-size: 30px;
    border: 1px solid #e4e7ed;
    border-radius: 10px;
    outline: none;
    box-sizing: border-box;
    &:focus {
      // 对齐 App 主题色聚焦态
      border-color: var(--theme-color);
    }
  }
}
.paystack-email-btn {
  width: 100%;
  height: 80px;
  line-height: 80px;
  // 对齐 App 主按钮：主题色背景
  background: var(--theme-color);
  color: #ffffff;
  font-family: @font-medium;
  font-size: 32px;
  font-weight: bold;
  border-radius: @radius-btn;
  text-align: center;
  cursor: pointer;
}
</style>
